// Usuarios que ven el reporte OPE (botón Gestorpre del header + pestaña OPE).
// Es la única lista: header, gestorpre y general la importan de aquí.
// Para dar de alta un grupo nuevo, agrega aquí el _id de sus usuarios administradores.
export const OPE_USER_IDS: string[] = [
  // Ruta
  '6320e86f8d18080445b86e8b',
  // Petrum
  '63ea868c2e2b2466c3a57f50', '68e940fb949be51ef56e6c73', '688b6320556daff83eca81d7',
  // Divitsa
  '6aa08df681f460d9eceea35b', '6aa08e8081f460d9eceea37f', '6aa08ed581f460d9eceea97f'
];

export const hasOpeAccess = (userId: string | null | undefined): boolean =>
  !!userId && OPE_USER_IDS.includes(userId);
